import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/brand@1x.png'
import _imports_1 from '../assets/brand@2x.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-75952036")

_pushScopeId("data-v-75952036")
const _hoisted_1 = _imports_1
const _hoisted_2 = { class: "skuinfo-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container-decorator header" }, null, -1)
const _hoisted_4 = { class: "sku-container-main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "padding padding-left" }, null, -1)
const _hoisted_6 = { class: "container-center" }
const _hoisted_7 = { class: "section-info" }
const _hoisted_8 = { class: "info-value title-value" }
const _hoisted_9 = { class: "section-info" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "info-label" }, "供应商：", -1)
const _hoisted_11 = { class: "info-value" }
const _hoisted_12 = { class: "section-info" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "info-label" }, "运输方式：", -1)
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = {
  key: 0,
  class: "section-info"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { class: "info-label" }, "生产日期：", -1)
const _hoisted_17 = { class: "info-value" }
const _hoisted_18 = { class: "info-label" }
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = {
  key: 2,
  class: "section-info"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "info-label" }, "产地：", -1)
const _hoisted_22 = { class: "info-value" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "brand-container" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "brand-pic",
    src: _imports_0,
    alt: "叮咚买菜商标",
    srcset: _hoisted_1
  })
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "padding padding-right" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_2, [
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.skuName), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("label", _hoisted_11, _toDisplayString(_ctx.vendorName), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("label", _hoisted_14, _toDisplayString(_ctx.storageDesc), 1)
        ]),
        (!_ctx.showNewDate)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.manufactureDate), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showNewDate)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.productionLabels, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "section-info",
                key: item.name + item.value
              }, [
                _createVNode("label", _hoisted_18, _toDisplayString(item.name) + "：", 1),
                _createVNode("label", _hoisted_19, _toDisplayString(item.value), 1)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("", true),
        (_ctx.originName)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("label", _hoisted_22, _toDisplayString(_ctx.originName), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_23
      ]),
      _hoisted_24
    ])
  ]))
})